import { Lightning as lng, Lightning } from '@lightningjs/sdk';
import { CmsConstants } from '../../Business/cms/CmsConstants';
import { Theme } from '../../config/theme';

export class CmsCardImage extends Lightning.Component {
  static _template() {
    const dims = CmsConstants.Card;
    return {
      Background: {
        x: 0,
        y: 0,
        w: w => w,
        h: h => h,
        rect: true,
        color: Theme.Colors.Ribbon.Card.Background,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: dims.innerRadius,
        },
      },
      Image: {
        x: 0,
        y: 0,
        w: w => w,
        h: h => h,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: dims.innerRadius,
        },
        NormalImage: {
          visible: false,
          mount: 0.5,
          x: w => w / 2,
          y: h => h / 2,
          w: w => w,
          h: h => h,
          texture: {
            type: lng.textures.ImageTexture,
            src: '',
          },
        },
        ContainImage: {
          visible: false,
          mount: 0.5,
          x: w => w / 2,
          y: h => h / 2,
          texture: {
            type: lng.textures.ImageTexture,
            src: '',
            resizeMode: {
              type: 'contain',
              w: 200,
              h: 100,
            },
          },
        },
      },
      ChannelLogo: {
        mountX: 1,
        x: w => w - 8,
        y: 8,
        w: 100,
        h: 50,
        visible: false,
        Contain: {
          mount: 0.5,
          x: w => w / 2,
          y: h => h / 2,
          texture: {
            type: lng.textures.ImageTexture,
            src: '',
            resizeMode: {
              type: 'contain',
              w: 100,
              h: 50,
            },
          },
        },
      },
    };
  }

  _init() {
    super._init();
    this._containImg = false;
  }

  set containImage(val) {
    this._containImg = val;
  }

  set imageUrl(val) {
    // Check if contain image should be used, refactor to always use contain
    if (this._containImg) {
      this.tag('ContainImage').visible = true;
      this.tag('ContainImage').patch({
        texture: {
          src: val,
          resizeMode: {
            type: 'contain',
            w: this.finalW,
            h: this.finalH,
          },
        },
      });
    } else {
      this.tag('NormalImage').visible = true;
      this.tag('NormalImage').patch({
        w: w => w,
        h: h => h,
        texture: {
          src: val,
        },
      });
    }
  }

  updateRoundedRects(cardHasExtraInfo) {
    let radius = CmsConstants.Card.innerRadius;
    if (cardHasExtraInfo) {
      radius = [CmsConstants.Card.innerRadius, CmsConstants.Card.innerRadius, 0, 0];
    }
    this.tag('Background').shader.radius = radius;
    this.tag('Image').shader.radius = radius;
  }

  set channelLogo(val) {
    this.tag('Contain').texture.src = val;
    this.tag('ChannelLogo').visible = true;
  }
}
